<template>
    <div class="w-100">
        <iframe id="isign-gateway" width="100%" height="1000px" :src="signingUrl"/>
        <div class="w-100 text-center mt-2">
            <v-btn color="red" class="text--white" v-show="!isSuccessful" @click="setSigningUrl(null)">{{ t("Cancel signing") }}</v-btn>
            <v-btn color="green" class="text--white" v-show="isSuccessful" @click="setShowSuccess(true)">{{ t("Finish signing") }}</v-btn>
        </div>
    </div>
</template>

<script>

import {mapActions, mapMutations, mapState} from "vuex";

export default {
    name: "dokobit-signing-window",
    data() {
        return {
            alreadyLoadedData: true,
            isSuccessful: false
        }
    },
    computed: {
        ...mapState('onboarding', ['signingUrl'])
    },
    async created() {
        const dokobitUrl = "https://gateway.dokobit.com/js/isign.frame.js";
        const jQueryUrl = "https://code.jquery.com/jquery-3.6.0.min.js";
        if (document.querySelectorAll(`[src="${jQueryUrl}"]`).length == 0) {
            setTimeout(async () => {
                let jQ = document.createElement("script");
                jQ.setAttribute("src", jQueryUrl);
                jQ.setAttribute("integrity", "sha256-/xUj+3OJU5yExlq6GSYGSHk7tPXikynS7ogEvDej/m4=");
                jQ.setAttribute("crossorigin", "anonymous");
                await document.head.appendChild(jQ);
            }, 200);
        }
        if (document.querySelectorAll(`[src="${dokobitUrl}"]`).length == 0) {
            this.alreadyLoadedData = false;
            setTimeout(async () => {
                let jQ = document.createElement("script");
                jQ.setAttribute("src", "https://code.jquery.com/jquery-3.6.0.min.js");
                jQ.setAttribute("integrity", "sha256-/xUj+3OJU5yExlq6GSYGSHk7tPXikynS7ogEvDej/m4=");
                jQ.setAttribute("crossorigin", "anonymous");
                await document.head.appendChild(jQ);
                let s = document.createElement("script");
                s.setAttribute("src", dokobitUrl);
                await document.head.appendChild(s);
            }, 400);
        }
    },
    mounted() {
        if (!this.alreadyLoadedData) {
            this.alreadyLoadedData = true;
            setTimeout(() => {
                window.Isign.onSignSuccess = async () => {
                    const response = await this.downloadDokobitFile();
                    if (!response) {
                        console.error("Error")
                    } else {
                        this.isSuccessful = true;
                        window.scrollTo({top: document.body.scrollHeight, behavior: "smooth"});
                    }
                };
                window.Isign.onSignError = async (errors) => {
                    let message = errors.join(", ");
                    console.error(message)
                    this.setShowError(true);
                };
                window.Isign.adjustHeight = async (props) => {
                    console.log(props);
                };
            }, 2000);
        }
    },
    methods: {
        ...mapActions('onboarding', ['downloadDokobitFile']),
        ...mapMutations('onboarding', ['setShowSuccess', 'setShowError', 'setSigningUrl'])
    }
}
</script>

<style scoped lang="scss">
.w-100 {
    width: 100%;
}
.text--white {
    color: white;
}
</style>